(function() {
    var searchInput = 'input[name="search"]';
    var quickSearchResults = '[data-trade-in-quicksearch-list]';
    var quickSearchResultsContainer = '[data-trade-in-search-results]';
    var promise = null;
    var autoCompleteTimer = null;
    var QuickSearchException = {
        name: 'quicksearch error',
        level: 'non-blocker',
        message: 'Couldn\'t find any matching handsets',
        get htmlMessage() {
            return '<li>' + this.message + '</li>';
        }
    };

    $(document).on('keyup click', searchInput, function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode >= 37 && keyCode <= 40) {
            return false;
        }

        if (isInBasket()) {
            if (keyCode === 13) {
                return false;
            }
        }

        if (autoCompleteTimer !== null) {
            clearTimeout(autoCompleteTimer);
            autoCompleteTimer = null;
        }

        var currentText = $(this).val();
        if (currentText.length < 3) {
            return;
        }
        $(quickSearchResultsContainer).removeClass('hide');
        $(quickSearchResults).empty();
        $(quickSearchResults).append('<li data-searching-message >Searching...</li>');

        var autoCompleteUrl = $(this).data('autoCompleteUrl');

        if (promise) {
            promise.abort();
        }
        autoCompleteTimer = setTimeout(function() {
            promise = $.post({
                url: autoCompleteUrl,
                data: {
                    'search': currentText
                },
                success: quickSearchSuccess,
                error: quickSearchError
            });
        }, 1000);
    });

    var quickSearchSuccess = function(data) {
        var results = data.results;
        $(quickSearchResults).empty();
        if (results.length === 0) {
            $(quickSearchResults).empty();
            $(quickSearchResults).append('<li>No handset found</li>');
        }

        results.forEach(function(item) {
            $(quickSearchResults).append('<li data-search-value role="button" data-handset-token="'
                + item.handsetToken
                + '" data-make-token="' + item.makeToken + '" '
                + '" data-model-id="' + item.modelId + '">'
                + item.title + '</li>');
        });

        return false;
    };

    $(document).on('click', '[data-searching-message]', function(e) {
        e.stopPropagation();
    });

    $(document).on('submit', 'form[name="tradeInSearch"]', function() {
        if (isInBasket()) {
            return false;
        }
    });

    $(document).on('click', '[data-search-value]', function() {
        var nextStepPath = $(quickSearchResults).data('tradeInProductDetailsPath')
            + '/' + $(this).data('makeToken')
            + '/' + $(this).data('handsetToken')
            + '?mid=' + $(this).data('modelId');
        var tradeInBasketContainer = $('[data-trade-in-basket-container]');
        if (tradeInBasketContainer.length) {
            tradeInBasketContainer.load(nextStepPath, function() {
                window.dispatchEvent(new CustomEvent('basket:trade-in:product-loaded'));
            });
        } else {
            window.location = nextStepPath;
        }
    });

    var quickSearchError = function() {
        try {
            if (promise) {
                return;
            }
            throw QuickSearchException;
        } catch (e) {
            handleQuickSearchException(e);
        }
    };

    var handleQuickSearchException = function(e) {
        if (e === QuickSearchException) {
            if ($(quickSearchResults).hasClass('hide')) {
                $(quickSearchResults).removeClass('hide');
            }
            $(quickSearchResults).empty();
            $(quickSearchResults).append(e.htmlMessage);
        }
    };

    var onMouseEnterSearchResult = function() {
        $(this).addClass('bg-primary');
    };

    var onMouseLeaveSearchResult = function() {
        $(this).removeClass('bg-primary');
    };

    $(document).on('click', 'button[name=searchButton]', function(e) {
        if (isInBasket()) {
            e.preventDefault();
            e.stopPropagation();
        }
    });

    $(document).on('click', function() {
        if (!$(searchInput).is(':focus')) {
            if (!$(quickSearchResultsContainer).hasClass('hide')) {
                $(quickSearchResultsContainer).addClass('hide');
                $(quickSearchResults).empty();
            }
        }
    });

    var init = function() {
        $(quickSearchResults).on({
            mouseenter: onMouseEnterSearchResult,
            mouseleave: onMouseLeaveSearchResult
        }, '*');
    };
    init();
})($);

function isInBasket() {
    return $('[data-trade-in-basket-container]').length > 0;
}
